import React from "react";
import { Modal } from "../_components";
import { useModal, useTime } from "../_contexts";

import { CalendarEditorForm } from "./forms";
import { CalendarEditor } from "./forms/CalendarEditor/CalendarEditor";

export function CalendarManager({ prevModal }) {
  // const { calendar } = useTime();
  const { closeModal } = useModal();
  return (
    <Modal
      id="calendarManagerModal"
      title="Calendars Manager"
      icon="far fa-calendar-edit fa-fw"
      size="lg"
      open
      unscrollable
      onClose={() => closeModal()}
    >
      {/* <CalendarEditorForm
        prevModal={prevModal}
        months={calendar.months}
        timeUnits={calendar.time}
      /> */}
      <CalendarEditor
        prevModal={prevModal}
        // months={[...calendar.months]}
        // timeUnits={{ ...calendar.time }}
      />
    </Modal>
  );
}
